import { Dayjs } from 'dayjs';

export enum AlarmLevel {
  LOWEST = 'LOWEST',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  HIGHEST = 'HIGHEST',
}

export enum MonitorType {
  PV = 'PV',
  LOAD = 'LOAD',
  THERMAL = 'THERMAL',
  STORAGE = 'STORAGE',
}

export interface DeviationAlarmRecord {
  id: number;
  monitorType: MonitorType;
  monitorObject: string;
  alarmRule: string;
  alarmRuleCode: string;
  alarmLevel: AlarmLevel;
  threshold: number;
  deviationRate: number;
  alarmTime: string;
  recoveryTime: string;
  dispatchSuggestion: number;
  actualExecution: number;
}

export interface AlarmFilters {
  alarmInfo?: string;
  monitorType?: MonitorType;
  monitorObject?: string;
  alarmTime?: [Dayjs | null, Dayjs | null];
  alarmLevel?: AlarmLevel;
}
